<template v-if="item && itemKey">
	<div class="gvf">
		<v-select
			v-if="hasFile"
			:tabindex="tabIndex"
			clearable
			small-chips
			readonly
			:label="gridViewField.Label"
			:items="fileItems"
			v-model="selectedFile"
			hide-details="auto"
			@click:clear="onClearExistingFile"
		>
			<template v-slot:selection="{ item }">
				<v-chip small label color="primary">{{ item.fileName }}</v-chip>
			</template>
		</v-select>
		<v-file-input
			v-else
			:disabled="isNull || isBulkEdit"
			:tabindex="tabIndex"
			@change="changeValue"
			:label="gridViewField.Label"
			hide-details="auto"
			v-model="value"
		>
			<template v-slot:selection="{}">
				<v-chip small label color="primary">{{
					item[itemKey + '_FileName']
				}}</v-chip>
			</template>
		</v-file-input>
		<v-checkbox
			:disabled="isBulkEdit"
			v-if="isBulkEdit"
			v-model="isNull"
			label="Set field to null"
			class="ma-0"
			hide-details
			@change="onClearExistingFile()"
		></v-checkbox>
		<span mt-2 v-if="isBulkEdit"
			><i>Files cannot be handled using Bulk Edit</i></span
		>
	</div>
</template>
<script>
import gridViewFieldsUtils from '../../../../utils/gridViewFieldsUtils';
import gridFieldMixin from '../../../../mixins/grids/gridFieldMixin';
export default {
	//TODO: open file btn
	name: 'FileField',
	mixins: [gridFieldMixin],
	data() {
		return {
			value: [],
			selectedFile: null,
		};
	},
	computed: {
		hasFile() {
			if (!this.item) return false;
			if (!this.item[this.itemKey + '_Path']) return false;
			return true;
		},

		fileItems() {
			if (!this.selectedFile) return [];
			return [this.selectedFile];
		},
		itemKey() {
			if (!this.gridViewField) return null;
			return gridViewFieldsUtils.getFieldName(this.gridViewField);
		},
	},
	mounted() {
		this.selectedFile = this.getSelectedFile();
	},
	methods: {
		getSelectedFile() {
			if (!this.hasFile) return null;
			return {
				path: this.item[this.itemKey + '_Path'],
				fileName: this.item[this.itemKey + '_FileName'],
				id: this.item[this.itemKey],
			};
		},
		test() {
			window.open(this.item[this.itemKey + '_Path']);
		},
		changeValue(val) {
			let recordKey = [{ key: this.key, value: val }];
			let itemKey = [
				{
					key: gridViewFieldsUtils.getFieldName(this.gridViewField),
					value: val,
				},
				{
					key:
						gridViewFieldsUtils.getFieldName(this.gridViewField) +
						'_FileName',
					value: val.name,
				},
			];
			this.$emit('valueChanged', itemKey, recordKey, this.isNull);
		},
		onClearExistingFile() {
			let recordKey = [{ key: this.key, value: null }];
			let itemKey = [
				{
					key: gridViewFieldsUtils.getFieldName(this.gridViewField),
					value: null,
				},
				{
					key:
						gridViewFieldsUtils.getFieldName(this.gridViewField) +
						'_FileName',
					value: null,
				},
				{
					key:
						gridViewFieldsUtils.getFieldName(this.gridViewField) +
						'_Path',
					value: null,
				},
			];
			this.$emit('valueChanged', itemKey, recordKey, this.isNull);
		},
	},
};
</script>

<style lang="scss">
.v-select__slot .v-input__append-inner .v-input__icon--append {
	display: none !important;
}
</style>
